const bwipjs = require('bwip-js');
import { replaceInvoiceLabel } from '../utils/invoiceLabel';

export default {
  async invoice(invoice, receiptBusiness, settings) {

    const content = [];
    let itemCount = 0;

    const canvas = document.createElement('canvas');

    const barcode = await new Promise((resolve, reject) => {
      bwipjs(
        canvas,
        {
          bcid: 'code128', // Barcode type
          text: invoice.localId.toString(), // Text to encode
          scale: 3, // 3x scaling factor
          height: 3, // Bar height, in millimeters
          includetext: false, // Show human-readable text
          textxalign: 'center', // Always good to set this
        },
        async (err, cvs) => {
          if (err) {
            // Decide how to handle the error
            // `err` may be a string or Error object
            reject(err);
          } else {
            resolve(canvas.toDataURL('image/png'));
          }
        },
      );
    });

    const qrbarcode = await new Promise((resolve, reject) => {
      bwipjs(
        canvas,
        {
          bcid: 'qrcode', // Barcode type
          text: invoice.id.toString(), // Text to encode
        },
        (err, cvs) => {
          if (err) {
            // Decide how to handle the error
            // `err` may be a string or Error object
            reject(err);
          } else {
            resolve(canvas.toDataURL('image/png'));
          }
        },
      );
    });

    // getting change
    await Promise.all(
      invoice.PaymentDetails.map((payment) => {
        if (
          settings.moment(invoice.createdAt).diff(
            payment.createdAt,
            'minutes',
          ) !== 0
        ) {
          settings.detailedPayment = true;
        }
      }),
    );

    content.push(
      {
        columns: [
          [
            {
              alignment: 'justify',
              columns: [
                [
                  {
                    columns: [
                      { text: replaceInvoiceLabel('Invoice # ', receiptBusiness), width: 70, alignment: 'left' },
                      { text: invoice.localId, width: 'auto', alignment: 'left' },
                    ],
                    columnGap: 10,
                  },
                  {
                    columns: [
                      { text: 'Created At ', width: 70, alignment: 'left' },
                      { text: settings.date, width: 'auto', alignment: 'left' },
                    ],
                    columnGap: 10,
                  },
                  {
                    columns: [
                      { text: 'Created By ', width: 70, alignment: 'left' },
                      { text: settings.capitalize(invoice.User.name), width: 'auto', alignment: 'left' },
                    ],
                    columnGap: 10,
                  },
                ],
              ],
              columnGap: 5,
            },
          ],
          [
            { image: barcode, width: 120, alignment: 'right', margin: [0, 20, 10, 0] },
          ],
        ],
        style: 'invoiceAddress',
      },
    )

    content.push(settings.horizontalLine);
    // content.push(
    //   [
    //     {
    //       canvas: [
    //         { type: 'line', x1: 0, y1: 2, x2: 570, y2: 2, lineWidth: 0.5 }, // First line
    //         { type: 'line', x1: 0, y1: 4, x2: 570, y2: 4, lineWidth: 0.5 } // Second line
    //       ],
    //       margin: [0, 5, 0, 5],
    //     },
    //   ],
    // )


    if (!invoice.due) {
      content.push({
        text: replaceInvoiceLabel('*** OPEN INVOICE ***', receiptBusiness),
        alignment: 'center',
        bold: true,
        big: true,
        fontSize: 20,
        bold: true,
        margin: [0, 10, 0, 5],
      });
    }

    const testCont = []

    const processDetail = async (detail) => {
      itemCount += parseFloat(detail.qty)

      const productName = detail.name
      const columns = [
        {
          text: productName,
          alignment: 'left',
        },
      ];

      columns.push({
          text: `${settings.options.filters.currency(detail.price)}`,
          alignment: 'right',
        });

      columns.push({
        text: `${parseFloat(detail.qty)}`,
        alignment: 'center',
      })

      columns.push({
        text: `${settings.options.filters.currency(
          detail.price * detail.qty)}`,
        alignment: 'right',
      });

      testCont.push(columns)
    };


    await invoice.InvoiceDetails.reduce(async (prev, curr) => {
      await prev;
      return processDetail(curr);
    }, Promise.resolve());



    console.log('testCont', testCont)
    content.push(
      {
        style: 'tableExample',
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#E0E0E0' : null;
          },
          hLineWidth: function (i, node) { return 0; }, // Removes horizontal borders
          vLineWidth: function (i, node) { return 0; }, // Removes vertical borders
        },
        table: {
          widths: ['*', 75, 75, 75],
          body: [
            [{ text: 'Description', bold: true }, { text: 'Price', bold: true }, { text: 'QTY', alignment: 'center', bold: true }, { text: 'Total', alignment: 'center', bold: true }],
            ...testCont,
          ],
        },
      },
    )

    content.push(settings.horizontalLine);
    // content.push(
    //   [
    //     {
    //       canvas: [
    //         { type: 'line', x1: 0, y1: 2, x2: 570, y2: 2, lineWidth: 0.5 }, // First line
    //         { type: 'line', x1: 0, y1: 4, x2: 570, y2: 4, lineWidth: 0.5 } // Second line
    //       ],
    //       margin: [0, 0, 0, 5],
    //     },
    //   ]
    // )

    const totalColumns = []

    totalColumns.push({
      columns: [
        { text: 'Sub Total', alignment: 'right' },
        {
          text: settings.options.filters.currency(invoice.total),
          alignment: 'right',
          bold: true,
        },
      ],
    });

    totalColumns.push({
      columns: [
        { text: 'Total Paid', alignment: 'right' },
        {
          text: settings.options.filters.currency(invoice.payment),
          alignment: 'right',
          bold: true,
        },
      ],
    });

    totalColumns.push({
      columns: [
        { text: 'Invoice Due', alignment: 'right' },
        {
          text: settings.options.filters.currency(invoice.due),
          alignment: 'right',
          bold: true,
        },
      ],
      bold: true,
    });





    let pointsEarned = 0;
    const pointsUsed = 0;

    totalColumns.push(settings.horizontalLine);


    if (settings.detailedPayment) {
      totalColumns.push({
        text: 'PAYMENTS',
        alignment: 'center',
        margin: [0, 5, 0, 10],
      });

      totalColumns.push({
        columns: [
          { text: 'DATE', alignment: 'left' },
          { text: '', alignment: 'center' },
          { text: 'AMOUNT', alignment: 'right' },
        ],
        bold: false,
      });
    }

    await Promise.all(
      invoice.PaymentDetails.map((payment) => {
        if (settings.detailedPayment) {
          totalColumns.push({
            columns: [
              {
                text: settings.moment(payment.createdAt).format(
                  'MM/DD/YY hh:mm a',
                ),
                alignment: 'left',
                width: 'auto',
              },
              {
                text: '',
                alignment: 'left',
              },
              {
                text: `${payment.Payment.paymentMethod}`,
                alignment: 'left',
              },
              {
                text: settings.options.filters.currency(payment.amount),
                alignment: 'right',
              },
            ],
            bold: false,
          });
        } else {
          let paymentLabel = payment.Payment.paymentMethod;
          totalColumns.push({
            columns: [
              {
                text: paymentLabel,
                alignment: 'right',
              },
              {
                text: settings.options.filters.currency(payment.amount),
                alignment: 'right',
              },
            ],
            bold: false,
          });
        }
      }),
    );



    if (
      !settings.detailedPayment
    ) {
      totalColumns.push({
        columns: [
          { text: 'Balance Due', alignment: 'right', big: true },
          {
            text: settings.options.filters.currency(invoice.due),
            alignment: 'right',
            big: true,
            bold: true,
          },
        ],
        bold: true,
        margin: [0, 5, 0, 5],
      });
    }

    content.push({
      columns: [
        totalColumns
      ]
    })

    if (
      !invoice.due
    ) {
      content.push({ text: ' ' });
      content.push({
        text: 'Paid In Full',
        fontSize: 32,
        alignment: 'center',
        bold: true
      });
    }

    content.push({
      text: settings.moment(invoice.createdAt).format('LT'),
      alignment: 'center',
      big: true,
    });

    content.push(settings.horizontalLine);

    if (invoice.note) {
      content.push({
        text: ' ',
      });
      content.push({
        text: invoice.note,
        small: true,
        bold: true,
        alignment: 'left',
      });
    }

    // Space
    content.push({
      text: ' ',
    });

    if (receiptBusiness.policy) {
      content.push({
        text: receiptBusiness.policy,
        margin: [0, 10, 0, 10],
        style: 'policy',
        small: true,
        alignment: 'left',
      });
    }
    content.push({
      image: qrbarcode,
      width: settings.width * 0.2,
      alignment: 'center',
      margin: [10, 10, 10, 10],
    });



    content.push({
      text: ' ',
      newLine: true,
    });
    return content;
  },

  async invoiceHeader(invoice, receiptBusiness, settings){
    let base64 = null
    if (receiptBusiness.imageUrl) {
      try {
        const toDataURL = (url) =>
          fetch(url, { mode: 'cors' })
            .then((response) => response.blob())
            .then(
              (blob) =>
                new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                }),
            );

        base64 = await toDataURL(receiptBusiness.imageUrl).then(
          (dataUrl) => dataUrl,
        );
      } catch (error) {
        console.log('image through error', error);
      }
    }
    let imageColumn = null
    if(base64){
      imageColumn = {
        image: base64,
        width: 130,
        height: 63,
        alignment: 'right',
      }
    }
    const header = {
      stack: [
        {
          alignment: 'left',
          margin: 8,
          columnGap: 10,
          columns: [
            {
              width: '*',
              stack: [
                { text: receiptBusiness.name, style: 'header'},
                { text: `${receiptBusiness.address1} ${receiptBusiness.city}, ${receiptBusiness.state} ${receiptBusiness.zip}`, 
                  style: 'invoiceAddress' },
                { text: settings.formatPhoneNumber(receiptBusiness.phoneNumber), style: 'invoiceAddress' },
                { text: receiptBusiness.email, style: 'invoiceAddress' }
              ]
            },
            imageColumn,
          ],
        },
        {canvas: [{ type: 'line', x1: 12, y1: 10, x2: 600, y2: 10, lineWidth: 1 }]},
        {
          alignment: 'left',
          margin: [12, 6, 8, 0],
          columnGap: 10,
          columns: [
            {
              width: '*',
              stack: [
                { text: `Customer:   ${invoice.Customer ? settings.capitalize(invoice.Customer.name) : 'Walk-In Customer'}`, style: 'invoiceAddress'},
                { text: `Address:    ${invoice.Customer ? invoice.Customer.address ? invoice.Customer.address : 'N/A' : 'N/A'}`, 
                  style: 'invoiceAddress' },
              ]
            },
            {
              width: '*',
              stack: [
                { text: `Phone:   ${invoice.Customer ? settings.formatPhoneNumber(invoice.Customer.phoneNumber) : '---'}`, style: 'invoiceAddress'},
                { text: `Email:    ${invoice.Customer ? invoice.Customer.email : '---'}`, 
                  style: 'invoiceAddress' },
              ]
            },
          ],
        },
        {canvas: [{ type: 'line', x1: 12, y1: 10, x2: 600, y2: 10, lineWidth: 1 }]},
      ]
    };
    return header;
  }
}
